/* ============================================
   GEMSENSE BLOG - Enhanced Article Scripts
   ============================================ */

/* --- Social Share (existing) --- */
class SocialShare extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.querySelectorAll('.btn-sharing').forEach(share => {
      share.addEventListener("click", event => {
        event.preventDefault();
        const target = event.currentTarget;
        const social = target.getAttribute('data-social');
        window.open(social);
      }, false);
    });
  }
}
customElements.define("social-share", SocialShare);

/* --- Article Enhancements --- */
(function () {
  const articleContent = document.getElementById('articleContent');
  if (!articleContent) return;

  /* ============================
     TABLE OF CONTENTS
     ============================ */
  function generateToc() {
    const headings = articleContent.querySelectorAll('h2, h3');
    if (headings.length < 2) {
      // Hide ToC if fewer than 2 headings
      const tocMobile = document.getElementById('articleTocMobile');
      const tocDesktop = document.getElementById('articleTocDesktop');
      if (tocMobile) tocMobile.style.display = 'none';
      if (tocDesktop) tocDesktop.style.display = 'none';
      return;
    }

    const tocList = document.createElement('ul');

    headings.forEach(function (heading, index) {
      // Create ID for heading
      var id = heading.id || heading.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
      // Ensure unique ID
      if (document.getElementById(id)) {
        id = id + '-' + index;
      }
      heading.id = id;

      // Add anchor link to heading
      var anchor = document.createElement('a');
      anchor.className = 'heading-anchor';
      anchor.href = '#' + id;
      anchor.textContent = '#';
      anchor.setAttribute('aria-label', 'Link to this section');
      heading.appendChild(anchor);

      // Create ToC item
      var li = document.createElement('li');
      if (heading.tagName === 'H3') {
        li.className = 'toc-h3';
      }
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = heading.textContent.replace(/#$/, '').trim();
      a.setAttribute('data-target', id);
      li.appendChild(a);
      tocList.appendChild(li);
    });

    // Populate desktop ToC
    var desktopNav = document.querySelector('#articleTocDesktop .article-toc-nav');
    if (desktopNav) {
      desktopNav.appendChild(tocList.cloneNode(true));
    }

    // Populate mobile ToC
    var mobileNav = document.querySelector('#articleTocMobile .article-toc-nav');
    if (mobileNav) {
      mobileNav.appendChild(tocList.cloneNode(true));
    }
  }

  /* ============================
     MOBILE TOC TOGGLE
     ============================ */
  function initMobileToc() {
    var tocMobile = document.getElementById('articleTocMobile');
    if (!tocMobile) return;

    var header = tocMobile.querySelector('.article-toc-header');
    if (!header) return;

    header.addEventListener('click', function () {
      tocMobile.classList.toggle('open');
      var expanded = tocMobile.classList.contains('open');
      header.setAttribute('aria-expanded', expanded.toString());
    });

    header.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        header.click();
      }
    });

    // Close mobile ToC when a link is clicked
    tocMobile.querySelectorAll('.article-toc-nav a').forEach(function (link) {
      link.addEventListener('click', function () {
        tocMobile.classList.remove('open');
        header.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ============================
     TOC SCROLL SPY
     ============================ */
  function initScrollSpy() {
    var tocLinks = document.querySelectorAll('.article-toc-nav a[data-target]');
    if (tocLinks.length === 0) return;

    var headingIds = [];
    tocLinks.forEach(function (link) {
      headingIds.push(link.getAttribute('data-target'));
    });

    var ticking = false;

    function updateActiveLink() {
      var scrollPos = window.scrollY + 120;
      var activeId = null;

      for (var i = headingIds.length - 1; i >= 0; i--) {
        var el = document.getElementById(headingIds[i]);
        if (el && el.offsetTop <= scrollPos) {
          activeId = headingIds[i];
          break;
        }
      }

      tocLinks.forEach(function (link) {
        if (link.getAttribute('data-target') === activeId) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateActiveLink);
        ticking = true;
      }
    }, { passive: true });

    // Initial call
    updateActiveLink();
  }

  /* ============================
     READING PROGRESS BAR
     ============================ */
  function initProgressBar() {
    var progressBar = document.getElementById('articleProgressBar');
    if (!progressBar) return;

    var ticking = false;

    function updateProgress() {
      var articleRect = articleContent.getBoundingClientRect();
      var articleTop = articleContent.offsetTop;
      var articleHeight = articleContent.offsetHeight;
      var windowHeight = window.innerHeight;
      var scrollY = window.scrollY;

      var start = articleTop;
      var end = articleTop + articleHeight - windowHeight;
      var progress = 0;

      if (scrollY >= start && end > start) {
        progress = ((scrollY - start) / (end - start)) * 100;
        progress = Math.min(Math.max(progress, 0), 100);
      } else if (scrollY > end) {
        progress = 100;
      }

      progressBar.style.width = progress + '%';
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateProgress);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ============================
     BACK TO TOP + FLOATING SHARE
     ============================ */
  function initScrollUI() {
    var backToTopBtn = document.getElementById('backToTop');
    var shareFloat = document.getElementById('articleShareFloat');
    var ticking = false;

    function checkScroll() {
      var scrollY = window.scrollY;
      // Back to top
      if (backToTopBtn) {
        if (scrollY > 500) {
          backToTopBtn.classList.add('visible');
        } else {
          backToTopBtn.classList.remove('visible');
        }
      }
      // Floating share — show when past article start, hide near footer
      if (shareFloat) {
        var articleTop = articleContent.offsetTop;
        var articleBottom = articleTop + articleContent.offsetHeight;
        if (scrollY > articleTop - 100 && scrollY < articleBottom - 200) {
          shareFloat.classList.add('visible');
        } else {
          shareFloat.classList.remove('visible');
        }
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(checkScroll);
        ticking = true;
      }
    }, { passive: true });

    if (backToTopBtn) {
      backToTopBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    // Initial check
    checkScroll();
  }

  /* ============================
     COPY LINK BUTTONS (inline + floating)
     ============================ */
  function initCopyLink() {
    document.querySelectorAll('.btn-copy-link, .btn-copy-link-float').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-url') || window.location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            showCopied(btn);
          });
        } else {
          var input = document.createElement('input');
          input.value = url;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          showCopied(btn);
        }
      });
    });

    function showCopied(btn) {
      btn.classList.add('copied');
      var tooltip = btn.querySelector('.tooltip-content');
      var original = tooltip ? tooltip.textContent : '';
      if (tooltip) tooltip.textContent = 'Copied!';
      setTimeout(function () {
        btn.classList.remove('copied');
        if (tooltip) tooltip.textContent = original;
      }, 2000);
    }
  }

  /* ============================
     INIT ALL
     ============================ */
  generateToc();
  initMobileToc();
  initScrollSpy();
  initProgressBar();
  initScrollUI();
  initCopyLink();
})();
